import React, { Component } from "react";
import MaskedInput from 'react-text-mask';
import { isUndefined } from "util";

const classBtnUnselected = "btn btn-light btn-block";
const classBtnSelected = "btn btn-selected btn-block";

class CustomField extends Component {

    selectOption (action, id, val, campo) {
       // debugger;
        action(id, val.val);
        let campoSelected = document.getElementsByClassName("btn-selected");
        if(!isUndefined( campoSelected) && campoSelected.length > 0) {
            campoSelected[0].className = classBtnUnselected;
        }
        campo.className = classBtnSelected;
    }

    imprimeCampo() {
        if(this.props.type === "select") {
            // debugger;
            return (
                <div>
                    <h1>{this.props.title}</h1>
                    {this.props.options.map((val, ind) => 
                        <button key={ind} type="button" className={classBtnUnselected} onClick={e => this.selectOption(this.props.action,this.props.id, {val}, e.target)}>{val}</button>
                    )}
                </div>
            );
        }
        if(this.props.type === "hidden") {
            this.props.action(this.props.id, this.props.value);
            return (
                <input 
                    id={this.props.id}
                    type={this.props.type}
                    value={this.props.value}
                />
            );
        }
        if(this.props.type === "date") {
            return (
                <MaskedInput 
                    id={this.props.id}
                    autoFocus={this.props.autoFocus}
                    title={this.props.help}
                    alt={this.props.help}
                    className={this.props.className}
                    keepCharPositions="true"
                    placeholder={this.props.help}
                    onChange={e => this.props.action(this.props.id, e.target.value)}
                    mask={[/\d/,/\d/,'/',/\d/,/\d/,'/',/\d/,/\d/,/\d/,/\d/]}
                    required />
            );
        }
        if(this.props.type === "cpf") {
            return (
                <MaskedInput 
                    id={this.props.id}
                    autoFocus={this.props.autoFocus}
                    title={this.props.help}
                    alt={this.props.help}
                    className={this.props.className}
                    keepCharPositions="true"
                    placeholder={this.props.help}
                    onChange={e => this.props.action(this.props.id, e.target.value)}
                    mask={[/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/,'-',/\d/,/\d/]}
                    required />
            );
        }
        if(this.props.type === "mobile" || this.props.type === "dddMobile" ) {
            return (
                <MaskedInput 
                    id={this.props.id}
                    title={this.props.help}
                    alt={this.props.help}
                    autoFocus={this.props.autoFocus}
                    guide="true"
                    className={this.props.className} 
                    keepCharPositions="true"
                    placeholder={this.props.help}
                    onChange={e => this.props.action(this.props.id, e.target.value)} 
                    mask={ this.props.type === "dddMobile" ? ['(',/\d/,/\d/,')',/\d/,/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/] : [/\d/,/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/]}
                    required />
            );
        }
        if(this.props.type === "number") {
            return (
                <input 
                    id={this.props.id}
                    autoFocus={this.props.autoFocus}
                    type="text"
                    pattern="\d*"
                    title={this.props.help}
                    alt={this.props.help}
                    maxLength={this.props.maxLength}
                    className={this.props.className} 
                    placeholder={this.props.placeholder} 
                    onChange={e => this.props.action(this.props.id, e.target.value)} 
                    required />
            )
        }
        return (
            <input 
                id={this.props.id}
                autoFocus={this.props.autoFocus}
                type={this.props.type}
                title={this.props.help}
                alt={this.props.help}
                maxLength={this.props.maxLength}
                className={this.props.className} 
                placeholder={this.props.placeholder} 
                onChange={e => this.props.action(this.props.id, e.target.value)} 
                required />
        );
    }

    render() {
        //console.log(this.state);
        return ( this.imprimeCampo()
        );
    }
}

export default CustomField;
